import { useData } from '../useData';
import { formatStartpageData } from '../../formatters/startpageFormatter';

export const useStartpageData = station => {
  return useData({
    endpoint: 'startpages',
    filters: { Station: station },
    formatter: formatStartpageData,
  });
};
